<template>
  <div class="radio-stacked">
    <input
      :id="`${name}-${index}`"
      v-model="selected"
      :name="name"
      type="radio"
      :value="option.Value"
      data-vv-as="Feltet"
      :data-test="`study-input-${name}-${index}`"
      @change="$emit('update:modelValue', selected)"
    />
    <label :for="`${name}-${index}`" v-html="option.Label" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BaseRadioButtonsStackedStudy',
  emits: ['update:modelValue'],
  props: {
    option: {
      type: Object,
      default() {
        return {
          Label: '',
          Value: ''
        };
      }
    },
    name: {
      type: String,
      default() {
        return 'default-radio-button-name';
      }
    },
    index: {
      type: Number,
      default() {
        return null;
      }
    },
    modelValue: {}
  },
  data() {
    return {
      selected: this.modelValue
    };
  }
});
</script>
